/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DeployPraetorBody = zod
	.object({
		note: zod.string().optional().describe('Optional deploy note')
	})
	.describe('Request body for deploying a praetor draft');

export type DeployPraetorBody = zod.input<typeof DeployPraetorBody>;
export type DeployPraetorBodyOutput = zod.output<typeof DeployPraetorBody>;
